import React from 'react';
import ReactPDF, { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image } from '@react-pdf/renderer';
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import PdfPreview from 'ui-component/PdfPreview';
import { Grid, Stack, Typography } from '@mui/material';
import phetsarath_ot from '../../../assets/fonts/phetsarath_ot.ttf';
import logo from '../../../assets/images/Logo-Aone-Final-Full.png';
import { padding, textAlign, width } from '@mui/system';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import { ToWords } from 'to-words';

// Create styles

Font.register({
    family: 'phetsarath_ot',
    format: 'truetype',
    src: phetsarath_ot
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        flexDirection: 'row',
        fontSize: 12,
        // margin: 10,
        // padding: 10,
        // flexGrow: 1,
        fontFamily: 'phetsarath_ot'
    },
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    title: {
        padding: 10,
        fontSize: 24,
        textAlign: 'center',
        fontFamily: 'phetsarath_ot'
    },
    author: {
        fontSize: 12,
        textAlign: 'center',
        marginBottom: 40
    },
    subtitle: {
        fontSize: 18,
        margin: 12,
        fontFamily: 'phetsarath_ot'
    },
    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify',
        // fontFamily: 'Times-Roman'
        fontFamily: 'phetsarath_ot'
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 100
    },
    logo: {
        position: 'absolute',
        // marginVertical: 1,
        // marginHorizontal: 1,
        width: 80
    },
    header: {
        fontSize: 12,
        marginBottom: 20,
        textAlign: 'center',
        color: 'grey',
        fontFamily: 'phetsarath_ot'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    },
    table: {
        width: '100%'
    },
    rowTable: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #000',
        paddingTop: 0,
        // paddingBottom: 8,
        fontSize: 10
    },
    headerTable: {
        borderTop: 'none',
        fontSize: 10
    },
    boldTable: {
        fontWeight: 'bold',
        fontSize: 12
    },

    // So Declarative and unDRY 👌
    row0: {
        width: '7%',
        border: '1px solid #000',
        fontFamily: 'phetsarath_ot',
        borderRight: 'none',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        fontSize: 10,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        overflow: 'hidden'
    },
    row1: {
        width: '20%',
        border: '1px solid #000',
        fontFamily: 'phetsarath_ot',
        borderRight: 'none',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        fontSize: 10,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        overflow: 'hidden'
    },
    row2: {
        width: '30%',
        //width: '37%',
        border: '1px solid #000',
        fontFamily: 'phetsarath_ot',
        borderRight: 'none',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        fontSize: 10,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        overflow: 'hidden'
    },
    row3: {
        width: '22%',

        border: '1px solid #000',
        fontFamily: 'phetsarath_ot',
        borderRight: 'none',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        fontSize: 10,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        overflow: 'hidden'
    },
    row4: {
        width: '25%',
        border: '1px solid #000',
        fontFamily: 'phetsarath_ot',
        // borderRight: 'none',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        fontSize: 10,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        overflow: 'hidden'
    }
    // row5: {
    //     fontFamily: 'phetsarath_ot',
    //     width: '27%',
    //     border: '1px solid #000',
    //     paddingTop: 8,
    //     paddingBottom: 8,
    //     paddingLeft: 4,
    //     fontSize: 10,
    //     display: 'flex',
    //     flexDirection: 'row',
    //     flexWrap: 'wrap',
    //     overflow: 'hidden'
    // }
});
const toWords = new ToWords({
    localeCode: 'en-US',
    converterOptions: {
        currency: false,
        ignoreDecimal: false,
        ignoreZeroCurrency: false,
        doNotAddOnly: false
    }
});
// Create Document Component
const MyDocument = ({ data }) => (
    <Document>
        <Page size="A4" style={styles.body} wrap>
            <Image style={styles.logo} src={logo} />
            <Text style={styles.title}>Invoice</Text>
            <View style={{ padding: 50 }} wrap>
                <View style={{ paddingLeft: 5, position: 'absolute' }}>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>Invoice no. </Text>
                        <Text>{data.invoiceNumber}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>Customer no. </Text>
                        <Text>{data.customerID}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>Mobile: </Text>
                        <Text>{data.customers.mobile}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>Customer: </Text>
                        <Text>{data.customers.customerName}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>FinanceComment: </Text>
                        <Text style={styles.boldTable}>{data?.reference}</Text>
                    </View>
                </View>
                <View style={{ paddingLeft: '70%', position: 'absolute' }}>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>Date: </Text>
                        <Text>{moment(data.createdAt).format('DD-MM-yyyy HH:mm')}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>BranchCode: </Text>
                        <Text>{data.branchCode}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={styles.boldTable}>PaymentType: </Text>
                        <Text>{data.paymentType === 1 ? 'Cash' : data.paymentType === 2 ? 'Bank' : 'Credit'}</Text>
                    </View>
                </View>
            </View>
            {/* <View style={{ padding: 50 }} wrap>
                FinanceComment: {data?.reference}
            </View> */}
            {/* Header Table */}
            <View style={styles.table} wrap>
                <View style={[styles.rowTable, styles.boldTable, styles.headerTable]}>
                    <Text style={styles.row0}>No.</Text>
                    <Text style={styles.row1}>IMEI</Text>
                    <Text style={styles.row2}>Name</Text>
                    <Text style={styles.row3}>Model</Text>
                    <Text style={styles.row4}>Price(₭)</Text>
                    {/* <Text style={styles.row5}>{`Price(₭)`}</Text> */}
                </View>
                {/* Table */}
                {data.stockController.map((row, i) => (
                    <View key={i} style={[styles.rowTable, styles.headerTable]} wrap={false}>
                        <Text style={[styles.row0, { fontSize: 8 }]}>{i + 1}</Text>
                        <Text style={[styles.row1, { fontSize: 10 }]}>{row.imei}</Text>
                        <Text style={[styles.row2, { fontSize: 8 }]}>{row.productName}</Text>
                        <Text style={[styles.row3, { fontSize: 8 }]}>{row.model}</Text>
                        <Text style={[styles.row4, { fontSize: 10 }]}>
                            <NumberFormat
                                thousandsGroupStyle="thousand"
                                value={row.salePrice}
                                prefix="₭"
                                decimalSeparator="."
                                displayType="text"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true}
                            />
                        </Text>
                        {/* <Text style={[styles.row5, { fontSize: 8 }]}>
                           
                            <NumberFormat
                                thousandsGroupStyle="thousand"
                                value={row.salePrice * row.rateSale}
                                prefix="₭"
                                decimalSeparator="."
                                displayType="text"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true}
                            /> 
                        </Text> */}
                    </View>
                ))}
                {data.premiumstocks.length !== 0 && (
                    <>
                        <View style={[styles.rowTable, styles.boldTable, styles.headerTable, { paddingTop: 10 }]}>
                            <Text
                                style={{
                                    width: '100%',
                                    border: '1px solid #000',
                                    fontFamily: 'Times-Roman',
                                    textAlign: 'center',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    fontWeight: 700,
                                    fontSize: 12
                                    // paddingLeft: 4
                                }}
                            >
                                Premiums
                            </Text>
                        </View>
                        <View style={[styles.rowTable, styles.boldTable, styles.headerTable]}>
                            <Text style={styles.row0}>No.</Text>
                            <Text style={styles.row1}>Premiums ID</Text>
                            <Text style={styles.row2}>Premiums Name</Text>
                            <Text style={styles.row3}>Amount</Text>
                            <Text style={styles.row4}>Price(₭)</Text>
                            {/* <Text style={styles.row5}>{`Price(₭)`}</Text> */}
                        </View>
                        {data.premiumstocks.map((row, i) => (
                            <View key={i} style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text style={[styles.row0, { fontSize: 8 }]}>{i + 1}</Text>
                                <Text style={[styles.row1, { fontSize: 8 }]}>{row.premium_id}</Text>
                                <Text style={[styles.row2, { fontSize: 8 }]}>{row.premiumName}</Text>
                                <Text style={[styles.row3, { fontSize: 10 }]}>{row.amount}</Text>
                                <Text style={[styles.row4, { fontSize: 10 }]}>
                                    <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={row.value * row.amount}
                                        prefix="₭"
                                        decimalSeparator="."
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                    />
                                </Text>
                            </View>
                        ))}
                    </>
                )}

                {/* Footer table */}
                <View style={[styles.rowTable, styles.headerTable, { paddingTop: 10 }]} wrap={false}>
                    <Text
                        style={{
                            width: '57%',
                            border: '1px solid #000',
                            fontFamily: 'Times-Roman',
                            borderRight: 'none',
                            textAlign: 'center',
                            paddingTop: 8,
                            paddingBottom: 8
                            // paddingLeft: 4
                        }}
                    >
                        {toWords.convert(data.totalPayment)}
                    </Text>
                    <View
                        style={{
                            width: '47%'
                        }}
                    >
                        <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                            <Text
                                style={{
                                    width: '47%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    fontSize: '9',
                                    borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                Total ₭
                            </Text>
                            <Text
                                style={{
                                    width: '53%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    // borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={data.totalPayment}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Text>
                        </View>
                        {/* <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                            <Text
                                style={{
                                    width: '36%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    borderRight: 'none',
                                    fontSize: '9',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                Total ₭
                            </Text>
                            <Text
                                style={{
                                    width: '65%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    // borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={data.totalPayment * data.rateSale}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Text>
                        </View> */}
                    </View>
                </View>

                <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                    <Text
                        style={{
                            width: '15%',
                            border: '1px solid #000',
                            fontFamily: 'phetsarath_ot',
                            fontSize: '9',
                            borderRight: 'none',
                            textAlign: 'center',
                            paddingTop: 8,
                            paddingBottom: 8
                            // paddingLeft: 4
                        }}
                    >
                        Remark
                    </Text>
                    <Text
                        style={{
                            width: '42%',
                            border: '1px solid #000',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'center',
                            paddingTop: 8,
                            paddingBottom: 8
                            // paddingLeft: 4
                        }}
                    >
                        {data.description}
                    </Text>
                    <View
                        style={{
                            width: '47%'
                        }}
                    >
                        {/* <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                            <Text
                                style={{
                                    width: '36%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    fontSize: '9',
                                    borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                Discount
                            </Text>
                            <Text
                                style={{
                                    width: '65%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    // borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={0}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Text>
                        </View> */}
                        <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                            <Text
                                style={{
                                    width: '47%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    fontSize: '9',
                                    borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                A-one Wallet
                            </Text>
                            <Text
                                style={{
                                    width: '53%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    // borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={data.aonewallets !== null ? data.aonewallets.totalPayment : 0}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Text>
                        </View>
                        <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                            <Text
                                style={{
                                    width: '47%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    fontSize: '9',
                                    borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                Samsung Wallet
                            </Text>
                            <Text
                                style={{
                                    width: '53%',
                                    border: '1px solid #000',
                                    fontFamily: 'phetsarath_ot',
                                    // borderRight: 'none',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 4
                                }}
                            >
                                <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={0}
                                    prefix="₭"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                />
                            </Text>
                        </View>
                    </View>
                </View>

                <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                    <Text
                        style={{
                            width: '57%',
                            border: '1px solid #000',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            paddingTop: 8,
                            paddingBottom: 8,
                            paddingLeft: 4,
                            textAlign: 'center'
                        }}
                    >
                        Grand Total
                    </Text>
                    <Text
                        style={{
                            width: '47%',
                            border: '1px solid #000',
                            fontFamily: 'phetsarath_ot',
                            // borderRight: 'none',
                            paddingTop: 8,
                            paddingBottom: 8,
                            paddingLeft: 4
                        }}
                    >
                        <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={data.totalPayment - (data.aonewallets !== null ? data.aonewallets.totalPayment : 0)}
                            prefix="₭"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                        />
                    </Text>
                </View>
                {/* Approve and customer */}
                <View style={[styles.rowTable, styles.headerTable]} wrap={true}>
                    <Text
                        style={{
                            width: '50%',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'left',
                            paddingTop: 8,
                            paddingBottom: 8,
                            fontSize: 12
                            // paddingLeft: 4
                        }}
                    >
                        Approved By:
                    </Text>
                    <Text
                        style={{
                            width: '50%',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'left',
                            paddingTop: 8,
                            paddingBottom: 8,
                            fontSize: 12
                            // paddingLeft: 4
                        }}
                    >
                        Customer :
                    </Text>
                </View>
                {/* Approve and customer */}
                <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                    <Text
                        style={{
                            width: '50%',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'center',
                            paddingTop: 10,
                            paddingBottom: 8,
                            fontSize: 12
                            // paddingLeft: 4
                        }}
                    >
                        {data.ApproveBy}
                    </Text>
                    <Text
                        style={{
                            width: '50%',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'center',
                            paddingTop: 10,
                            paddingBottom: 8,
                            fontSize: 12
                            // paddingLeft: 4
                        }}
                    >
                        {data.customers.customerName}
                    </Text>
                </View>
                {/* signature */}

                <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }} wrap={false}>
                    <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                        <Text
                            style={{
                                width: '50%',
                                fontFamily: 'phetsarath_ot',
                                borderRight: 'none',
                                textAlign: 'left',
                                paddingTop: 10,
                                paddingBottom: 8,
                                fontSize: 10
                                // paddingLeft: 4
                            }}
                        >
                            Signature : .................................................................
                        </Text>
                        <Text
                            style={{
                                width: '50%',
                                fontFamily: 'phetsarath_ot',
                                borderRight: 'none',
                                textAlign: 'left',
                                paddingTop: 10,
                                paddingBottom: 8,
                                fontSize: 10
                                // paddingLeft: 4
                            }}
                        >
                            Signature : .................................................................
                        </Text>
                    </View>
                    <Text
                        style={{
                            width: '50%',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'left',
                            paddingTop: 8,
                            paddingBottom: 8,
                            fontSize: 10
                            // paddingLeft: 4
                        }}
                    >
                        Date : .................................................................
                    </Text>
                    <Text
                        style={{
                            width: '50%',
                            fontFamily: 'phetsarath_ot',
                            borderRight: 'none',
                            textAlign: 'left',
                            paddingTop: 8,
                            paddingBottom: 8,
                            fontSize: 10
                            // paddingLeft: 4
                        }}
                    >
                        Date : .................................................................
                    </Text>
                </View>
                {/* footer detail paper */}
                <View
                    style={{ border: '1px solid blue', borderRadius: '15px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
                    wrap={false}
                >
                    <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                        <Text
                            style={{
                                width: '100%',
                                fontFamily: 'phetsarath_ot',
                                color: 'blue',
                                borderRight: 'none',
                                textAlign: 'center',
                                paddingTop: 5,
                                paddingBottom: 8,
                                fontSize: 10,
                                fontWeight: 'bold'
                                // paddingLeft: 4
                            }}
                        >
                            METHODS OF PAYMENT
                        </Text>
                    </View>
                    <View wrap={false} style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        <View style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }} wrap={false}>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'left',
                                        paddingTop: 0,
                                        paddingLeft: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Bank Name: BCEL BANK CO.,LTD
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'left',
                                        paddingTop: 0,
                                        paddingLeft: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Account Name : A ONE DISTRIBUTORS CO.,LTD
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'left',
                                        paddingTop: 0,
                                        paddingLeft: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Accout No. 010/110/00/60034 USD
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'left',
                                        paddingTop: 0,
                                        paddingLeft: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Accout No. 010/110/00/60025 THB
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'left',
                                        paddingTop: 0,
                                        paddingLeft: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Accout No. 010/110/00/60016 LAK
                                </Text>
                            </View>
                        </View>
                        <View style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }} wrap={false}>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'right',
                                        paddingTop: 0,
                                        paddingRight: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Bank Name: BIC BANK
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'right',
                                        paddingTop: 0,
                                        paddingRight: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Account Name : A ONE DISTRIBUTORS CO.,LTD
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'right',
                                        paddingTop: 0,
                                        paddingRight: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Accout No. 0000-1010-0195-201 USD
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'right',
                                        paddingTop: 0,
                                        paddingRight: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    Accout No. 0000-1010-0195-109 THB
                                </Text>
                            </View>
                            <View style={[styles.rowTable, styles.headerTable]} wrap={false}>
                                <Text
                                    style={{
                                        width: '50%',
                                        fontFamily: 'phetsarath_ot',
                                        color: 'blue',
                                        borderRight: 'none',
                                        textAlign: 'right',
                                        paddingTop: 0,
                                        paddingRight: 10,
                                        paddingBottom: 0,
                                        fontSize: 10,
                                        fontWeight: 'bold'
                                        // paddingLeft: 4
                                    }}
                                >
                                    0000-1010-0195-006 LAK
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </Page>
    </Document>
);

const InvoicePDF = ({ data }) => {
    // if (isMobile) {
    //     return (
    //         <PDFDownloadLink document={<MyDocument />} fileName="YOUR_FILE_NAME">
    //             {/* {({ loading }) => (loading ? 'Loading...' : <ModalPDFGenerated />)} */}
    //         </PDFDownloadLink>
    //     );
    // }
    return (
        <>
            <PdfPreview document={<MyDocument data={data} />} fileName={data?.invoiceNumber} />
        </>
    );
};
export default InvoicePDF;
